import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "./apiClient";
const user = JSON.parse(localStorage.getItem("user"));
const username = user?.username || null;
// Thunks

export const fetchFaqsByIctId = createAsyncThunk(
  "ictFaq/fetchFaqsByIctId",
  async (ictId, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(`/ict-faq/ict/${ictId}`);
      return response.data; // Must include `user` field from backend
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const insertFaq = createAsyncThunk(
  "ictFaq/insertFaq",
  async (faqData, { getState, rejectWithValue }) => {
    try {
      const { auth } = getState(); // Access user from Redux auth

      const dataToSend = {
        ...faqData,
        user: username, // Attach user from Redux
      };

      const response = await apiClient.post("/ict-faq/", dataToSend);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const updateFaq = createAsyncThunk(
  "ictFaq/updateFaq",
  async ({ id, ...data }, { rejectWithValue }) => {
    try {
      const response = await apiClient.put(`/ict-faq/${id}`, data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const patchFaqStatus = createAsyncThunk(
  "ictFaq/patchFaqStatus",
  async ({ faq_id, status }, { rejectWithValue }) => {
    try {
      const response = await apiClient.patch(`/ict-faq/${faq_id}/status`, { status });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteFaq = createAsyncThunk(
  "ictFaq/deleteFaq",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiClient.delete(`/ict-faq/${id}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Slice

const ictFaqSlice = createSlice({
  name: "ictFaq",
  initialState: {
    faqs: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      // Fetch
      .addCase(fetchFaqsByIctId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFaqsByIctId.fulfilled, (state, action) => {
        state.loading = false;
        state.faqs = action.payload;
      })
      .addCase(fetchFaqsByIctId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Insert
      .addCase(insertFaq.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(insertFaq.fulfilled, (state, action) => {
        state.loading = false;
        state.faqs.push(action.payload);
      })
      .addCase(insertFaq.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update
      .addCase(updateFaq.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateFaq.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.faqs.findIndex((f) => f.id === action.payload.id);
        if (index !== -1) state.faqs[index] = action.payload;
      })
      .addCase(updateFaq.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Patch Status
      .addCase(patchFaqStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(patchFaqStatus.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.faqs.findIndex((f) => f.id === action.payload.id);
        if (index !== -1) state.faqs[index].status = action.payload.status;
      })
      .addCase(patchFaqStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Delete
      .addCase(deleteFaq.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteFaq.fulfilled, (state, action) => {
        state.loading = false;
        state.faqs = state.faqs.filter((f) => f.id !== action.payload.id);
      })
      .addCase(deleteFaq.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default ictFaqSlice.reducer;
